<template>
    <div id="app">
        <v-app id="inspire">
            <v-card v-model="show" color="#FFFF99">
                <v-card-title>
                    <h6>Listado de Portales Web</h6>
                </v-card-title>
                <v-card-text class="pt-2">
                    <v-row dense>
                        <v-col cols="6" sm="6" md="4">
                            <v-text-field label="Filtro por Link" dense v-model="filtrolink">
                            </v-text-field>
                        </v-col>
                        <v-col cols="6" sm="6" md="4">
                            <v-text-field label="Filtro por Empresa" dense v-model="filtroempresa">
                            </v-text-field>
                        </v-col>
                        <v-col cols="6" sm="6" md="4">
                            <v-text-field label="Filtro por Observaciones" dense v-model="filtroobserv">
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row align="center" justify="space-around">
                        <v-btn tile color="success" @click="cargarListado()">
                            <v-icon left> mdi-magnify </v-icon>
                            Buscar
                        </v-btn>
                    </v-row>
                </v-card-text>
            </v-card>
            <v-data-table dense :headers="headers" :items="listado" locale="es-ar" class="elevation-1"
                :items-per-page="500" :footer-props="{ itemsPerPageText: 'Portales por página', }" :loading="loadtable"
                loading-text="Cargando... Espere por favor" no-data-text="No hay datos disponibles">
                <template #item.link="{ item }">
                    <a :href="item.link" class="wrap-link">
                        {{ item.link }}
                    </a>
                </template>
                <template v-slot:item.actions="{ item }">
                    <!-- <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }"> -->
                    <v-icon small color="blue" class="mr-2" @click.stop="editar(item)">
                        mdi-pencil
                    </v-icon>
                    <!-- </template>
</v-tooltip> -->
                </template>
            </v-data-table>
            <Editar :visible="showEditar" :id="editedItem.id" @close="showEditar = false">
            </Editar>
        </v-app>
    </div>
</template>

<script>
import axios from "../../axios-auth.js";
import Editar from "../Comercial/Editarportales.vue"

export default {
    components: { Editar },
    data: (vm) => ({
        editedItem: {},
        editedIndex: -1,
        filtroempresa: "",
        filtrolink: "",
        filtroobserv: "",
        listado: [],
        loadtable: false,
        showEditar: false,
        headers: [
            { text: "Empresa", value: "empresa", sortable: false },
            { text: "Link", value: "link", width: "40%", sortable: false },
            { text: "Fecha", value: "fecha", sortable: false },
            { text: "Usuario", value: "usuario", sortable: false },
            { text: "Password", value: "password", sortable: false },
            { text: "Observaciones", value: "observ", sortable: false },
            { text: "Editar", value: "actions", sortable: false },

        ],
    }),
    computed: {
        show: {
            get() {
                //this.cargarLegajo();

                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.$emit("close");
                }
            },
        },
    },

    methods: {

        editar(item) {
            this.editedIndex = this.listado.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.showEditar = true;
        },

        cargarListado() {
            this.loadtable = true;
            const link = this.filtrolink;
            const empresa = this.filtroempresa;
            const observ = this.filtroobserv;

            let self = this;
            axios
                .get("/Comercial/ListadoPortales?", {
                    params: {
                        link: link,
                        observ: observ,
                        empresa: empresa,
                    },
                })
                .then((response) => {
                    self.listado = response.data;
                    self.loadtable = false;
                })
                .catch((error) => {
                    self.listado = [];
                    console.log(error);
                });
        },
    },
};
</script>

<style scoped>
.wrap-link {
    max-width: 300px;
    /* ajusta al ancho que quieras */
    display: block;
    overflow-wrap: anywhere;
    word-break: break-word;
    /* fallback */
}
</style>